export const MONTHS_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const WEEKDAYS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

export function parseYmd(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value || "").trim().slice(0, 10));
  if (!match) return null;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
}

export function toYmd(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function localTodayYmd() {
  return toYmd(new Date());
}

export function ymdToUs(ymd) {
  const date = parseYmd(ymd);
  if (!date) return "";
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${month}/${day}/${date.getFullYear()}`;
}

export function isYmdInRange(ymd, min, max) {
  if (!ymd) return false;
  if (min && ymd < min) return false;
  if (max && ymd > max) return false;
  return true;
}

export function monthIntersectsRange(year, monthIndex, min, max) {
  const start = toYmd(new Date(year, monthIndex, 1));
  const end = toYmd(new Date(year, monthIndex + 1, 0));
  if (max && start > max) return false;
  if (min && end < min) return false;
  return true;
}

export function yearBounds(min, max) {
  const todayYear = new Date().getFullYear();
  const minYear = parseYmd(min)?.getFullYear() ?? todayYear - 150;
  const maxYear = parseYmd(max)?.getFullYear() ?? todayYear + 30;
  return {
    minYear: Math.min(minYear, maxYear),
    maxYear: Math.max(minYear, maxYear),
  };
}

export function shiftMonth(year, monthIndex, delta) {
  const next = new Date(year, monthIndex + delta, 1);
  return { year: next.getFullYear(), month: next.getMonth() };
}

export function buildMonthCells(year, monthIndex) {
  const firstWeekday = new Date(year, monthIndex, 1).getDay();
  const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
  const cells = [];

  for (let index = 0; index < firstWeekday; index += 1) {
    const date = new Date(year, monthIndex, index - firstWeekday + 1);
    cells.push({ date, outside: true });
  }

  for (let day = 1; day <= daysInMonth; day += 1) {
    cells.push({ date: new Date(year, monthIndex, day), outside: false });
  }

  while (cells.length % 7 !== 0) {
    const previous = cells[cells.length - 1].date;
    const date = new Date(previous.getFullYear(), previous.getMonth(), previous.getDate() + 1);
    cells.push({ date, outside: true });
  }

  return cells;
}
